import { Injectable } from '@angular/core';
import { WiseIdAuthService } from '@solverml/api';
import { lastValueFrom } from 'rxjs';
import { UserResult } from '@rfebm/sso-api';


@Injectable({
  providedIn: 'root'
})
export class WiseIdAuthServiceManager {

  public readonly redirectUrl: string;

  constructor(
    private wiseIdAuthService: WiseIdAuthService
  ) {
    this.redirectUrl = window.location.protocol + "//" + window.location.hostname+"/after-login";
  }

  public async loginWithWiseId(authorizationCode: string): Promise<void | false> {

    try {
      const accessToken = await lastValueFrom(
        this.wiseIdAuthService.getAccessToken(authorizationCode,this.redirectUrl)
      );
      if (accessToken) {
        // Save the access token in session storage
        this.saveAccessToken(accessToken.access_token);
      } else {
        console.error('No access token received from Wise ID.');
        return false;
      }
      return;
    } catch (error) {
      console.error('Error during Wise ID login:', error);
    }

    return false;
  }

  public getAccessToken(): string | null {
    // Get the access token from session storage
    const accessToken = sessionStorage.getItem('wiseIdAccessToken');
    if (accessToken) {
      return accessToken;
    }
    // If the access token is not found, return null
    return null;
  }

  public isLoggedIn(): boolean {
    // Check if the access token exists in session storage
    return this.getAccessToken() !== null;
  }

  public logout(): void {
    // Remove the access token from session storage
    sessionStorage.clear();
  }

  public setUserSessionData(user: UserResult): void {
    // Save user data in session storage
    sessionStorage.setItem('wiseIdUser', JSON.stringify(user));
  }

  public getUserSessionData(): UserResult | null {
    // Retrieve user data from session storage
    const userData = sessionStorage.getItem('wiseIdUser');
    if (userData) {
      return JSON.parse(userData) as UserResult;
    }
    // If no user data is found, return null
    return null;
  }

  private saveAccessToken(accessToken: string): void {
    // Save the access token in session storage
    sessionStorage.setItem('wiseIdAccessToken', accessToken);
  }
}
